// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalV1MedicalBiResultDefaultResponseData {
    static getAttributeTypeMap() {
        return MedicalV1MedicalBiResultDefaultResponseData.attributeTypeMap;
    }
}
MedicalV1MedicalBiResultDefaultResponseData.discriminator = undefined;
MedicalV1MedicalBiResultDefaultResponseData.additionalProperties = false;
MedicalV1MedicalBiResultDefaultResponseData.attributeTypeMap = [
    {
        "name": "requestId",
        "baseName": "requestId",
        "type": "number"
    },
    {
        "name": "transactionDateTime",
        "baseName": "transactionDateTime",
        "type": "string"
    },
    {
        "name": "transactionId",
        "baseName": "transactionId",
        "type": "string"
    },
    {
        "name": "status",
        "baseName": "status",
        "type": "boolean"
    },
    {
        "name": "transactionMessage",
        "baseName": "transactionMessage",
        "type": "string"
    },
    {
        "name": "programId",
        "baseName": "programId",
        "type": "string"
    },
    {
        "name": "reviewRequired",
        "baseName": "reviewRequired",
        "type": "boolean"
    },
    {
        "name": "payerAgentName",
        "baseName": "payerAgentName",
        "type": "string"
    },
    {
        "name": "payerReferenceId",
        "baseName": "payerReferenceId",
        "type": "string"
    },
    {
        "name": "patientFirstName",
        "baseName": "patientFirstName",
        "type": "string"
    },
    {
        "name": "patientLastName",
        "baseName": "patientLastName",
        "type": "string"
    },
    {
        "name": "patientMiddleName",
        "baseName": "patientMiddleName",
        "type": "string"
    },
    {
        "name": "patientGender",
        "baseName": "patientGender",
        "type": "string"
    },
    {
        "name": "patientDateOfBirth",
        "baseName": "patientDateOfBirth",
        "type": "string"
    },
    {
        "name": "patientAddressLine1",
        "baseName": "patientAddressLine1",
        "type": "string"
    },
    {
        "name": "patientAddressLine2",
        "baseName": "patientAddressLine2",
        "type": "string"
    },
    {
        "name": "patientCity",
        "baseName": "patientCity",
        "type": "string"
    },
    {
        "name": "patientState",
        "baseName": "patientState",
        "type": "string"
    },
    {
        "name": "patientZipCode",
        "baseName": "patientZipCode",
        "type": "string"
    },
    {
        "name": "payerName",
        "baseName": "payerName",
        "type": "string"
    },
    {
        "name": "payerId",
        "baseName": "payerId",
        "type": "string"
    },
    {
        "name": "payerPhoneNumber",
        "baseName": "payerPhoneNumber",
        "type": "string"
    },
    {
        "name": "planName",
        "baseName": "planName",
        "type": "string"
    },
    {
        "name": "planFundType",
        "baseName": "planFundType",
        "type": "string"
    },
    {
        "name": "memberId",
        "baseName": "memberId",
        "type": "string"
    },
    {
        "name": "groupId",
        "baseName": "groupId",
        "type": "string"
    },
    {
        "name": "groupName",
        "baseName": "groupName",
        "type": "string"
    },
    {
        "name": "planPriority",
        "baseName": "planPriority",
        "type": "string"
    },
    {
        "name": "policyType",
        "baseName": "policyType",
        "type": "string"
    },
    {
        "name": "planType",
        "baseName": "planType",
        "type": "string"
    },
    {
        "name": "planRenewalType",
        "baseName": "planRenewalType",
        "type": "string"
    },
    {
        "name": "planEffectiveDate",
        "baseName": "planEffectiveDate",
        "type": "string"
    },
    {
        "name": "planTerminationDate",
        "baseName": "planTerminationDate",
        "type": "string"
    },
    {
        "name": "secondaryInsuranceExist",
        "baseName": "secondaryInsuranceExist",
        "type": "boolean"
    },
    {
        "name": "secondaryInsuranceName",
        "baseName": "secondaryInsuranceName",
        "type": "string"
    },
    {
        "name": "ndc",
        "baseName": "ndc",
        "type": "string"
    },
    {
        "name": "drugDescription",
        "baseName": "drugDescription",
        "type": "string"
    },
    {
        "name": "quantity",
        "baseName": "quantity",
        "type": "string"
    },
    {
        "name": "daysSupply",
        "baseName": "daysSupply",
        "type": "string"
    },
    {
        "name": "sig",
        "baseName": "sig",
        "type": "string"
    },
    {
        "name": "refill",
        "baseName": "refill",
        "type": "string"
    },
    {
        "name": "prescriberNpi",
        "baseName": "prescriberNpi",
        "type": "string"
    },
    {
        "name": "prescriberTaxId",
        "baseName": "prescriberTaxId",
        "type": "string"
    },
    {
        "name": "prescriberLastName",
        "baseName": "prescriberLastName",
        "type": "string"
    },
    {
        "name": "prescriberFirstName",
        "baseName": "prescriberFirstName",
        "type": "string"
    },
    {
        "name": "prescriberAddressLine1",
        "baseName": "prescriberAddressLine1",
        "type": "string"
    },
    {
        "name": "prescriberAddressLine2",
        "baseName": "prescriberAddressLine2",
        "type": "string"
    },
    {
        "name": "prescriberCity",
        "baseName": "prescriberCity",
        "type": "string"
    },
    {
        "name": "prescriberState",
        "baseName": "prescriberState",
        "type": "string"
    },
    {
        "name": "prescriberZipCode",
        "baseName": "prescriberZipCode",
        "type": "string"
    },
    {
        "name": "prescriberInNetwork",
        "baseName": "prescriberInNetwork",
        "type": "boolean"
    },
    {
        "name": "practiceName",
        "baseName": "practiceName",
        "type": "string"
    },
    {
        "name": "practiceNpi",
        "baseName": "practiceNpi",
        "type": "string"
    },
    {
        "name": "practiceAddressLine1",
        "baseName": "practiceAddressLine1",
        "type": "string"
    },
    {
        "name": "practiceAddressLine2",
        "baseName": "practiceAddressLine2",
        "type": "string"
    },
    {
        "name": "practiceCity",
        "baseName": "practiceCity",
        "type": "string"
    },
    {
        "name": "practiceState",
        "baseName": "practiceState",
        "type": "string"
    },
    {
        "name": "practiceZipCode",
        "baseName": "practiceZipCode",
        "type": "string"
    },
    {
        "name": "practiceTaxId",
        "baseName": "practiceTaxId",
        "type": "string"
    },
    {
        "name": "practicePhoneNumber",
        "baseName": "practicePhoneNumber",
        "type": "string"
    },
    {
        "name": "prescriberFaxNumber",
        "baseName": "prescriberFaxNumber",
        "type": "string"
    },
    {
        "name": "preferredSpecialtyPharmacy",
        "baseName": "preferredSpecialtyPharmacy",
        "type": "string"
    },
    {
        "name": "preferredSpecialtyPhoneNo",
        "baseName": "preferredSpecialtyPhoneNo",
        "type": "string"
    },
    {
        "name": "facilityName",
        "baseName": "facilityName",
        "type": "string"
    },
    {
        "name": "facilityNpi",
        "baseName": "facilityNpi",
        "type": "string"
    },
    {
        "name": "facilityAddressLine1",
        "baseName": "facilityAddressLine1",
        "type": "string"
    },
    {
        "name": "facilityAddressLine2",
        "baseName": "facilityAddressLine2",
        "type": "string"
    },
    {
        "name": "facilityCity",
        "baseName": "facilityCity",
        "type": "string"
    },
    {
        "name": "facilityState",
        "baseName": "facilityState",
        "type": "string"
    },
    {
        "name": "facilityZipCode",
        "baseName": "facilityZipCode",
        "type": "string"
    },
    {
        "name": "facilityPhoneNumber",
        "baseName": "facilityPhoneNumber",
        "type": "string"
    },
    {
        "name": "facilityFaxNumber",
        "baseName": "facilityFaxNumber",
        "type": "string"
    },
    {
        "name": "specialtyPharmacyCopay",
        "baseName": "specialtyPharmacyCopay",
        "type": "string"
    },
    {
        "name": "specialtyPharmacyCoInsurance",
        "baseName": "specialtyPharmacyCoInsurance",
        "type": "string"
    },
    {
        "name": "individualDeductibleTotal",
        "baseName": "individualDeductibleTotal",
        "type": "string"
    },
    {
        "name": "individualDeductibleMet",
        "baseName": "individualDeductibleMet",
        "type": "string"
    },
    {
        "name": "individualOopMaximum",
        "baseName": "individualOopMaximum",
        "type": "string"
    },
    {
        "name": "individualOopMet",
        "baseName": "individualOopMet",
        "type": "string"
    },
    {
        "name": "deductibleIncludedInOop",
        "baseName": "deductibleIncludedInOop",
        "type": "boolean"
    },
    {
        "name": "copay",
        "baseName": "copay",
        "type": "string"
    },
    {
        "name": "coInsurance",
        "baseName": "coInsurance",
        "type": "string"
    },
    {
        "name": "coPayNotes",
        "baseName": "coPayNotes",
        "type": "string"
    },
    {
        "name": "spendDownTotal",
        "baseName": "spendDownTotal",
        "type": "string"
    },
    {
        "name": "spendDownMet",
        "baseName": "spendDownMet",
        "type": "string"
    },
    {
        "name": "familyDeductibleTotal",
        "baseName": "familyDeductibleTotal",
        "type": "string"
    },
    {
        "name": "familyDeductibleMet",
        "baseName": "familyDeductibleMet",
        "type": "string"
    },
    {
        "name": "familyOopMaximum",
        "baseName": "familyOopMaximum",
        "type": "string"
    },
    {
        "name": "familyOopMet",
        "baseName": "familyOopMet",
        "type": "string"
    },
    {
        "name": "copayWaivedAfterOpp",
        "baseName": "copayWaivedAfterOpp",
        "type": "boolean"
    },
    {
        "name": "lifetimeMaximumAmount",
        "baseName": "lifetimeMaximumAmount",
        "type": "string"
    },
    {
        "name": "lifetimeMaximumMet",
        "baseName": "lifetimeMaximumMet",
        "type": "string"
    },
    {
        "name": "annualCapExist",
        "baseName": "annualCapExist",
        "type": "boolean"
    },
    {
        "name": "benefitsNotes",
        "baseName": "benefitsNotes",
        "type": "string"
    },
    {
        "name": "jCode",
        "baseName": "jCode",
        "type": "string"
    },
    {
        "name": "jCodeUnit",
        "baseName": "jCodeUnit",
        "type": "string"
    },
    {
        "name": "jCodeCopay",
        "baseName": "jCodeCopay",
        "type": "string"
    },
    {
        "name": "jCodeCoInsurance",
        "baseName": "jCodeCoInsurance",
        "type": "string"
    },
    {
        "name": "jCodeNotes",
        "baseName": "jCodeNotes",
        "type": "string"
    },
    {
        "name": "cptCode",
        "baseName": "cptCode",
        "type": "string"
    },
    {
        "name": "cptCodeUnit",
        "baseName": "cptCodeUnit",
        "type": "string"
    },
    {
        "name": "cptCopay",
        "baseName": "cptCopay",
        "type": "string"
    },
    {
        "name": "cptCoInsurance",
        "baseName": "cptCoInsurance",
        "type": "string"
    },
    {
        "name": "cptNotes",
        "baseName": "cptNotes",
        "type": "string"
    },
    {
        "name": "mutipleCoPay",
        "baseName": "mutipleCoPay",
        "type": "boolean"
    },
    {
        "name": "priorAuthorizationRequired",
        "baseName": "priorAuthorizationRequired",
        "type": "boolean"
    },
    {
        "name": "priorAuthorizationRequiredCodes",
        "baseName": "priorAuthorizationRequiredCodes",
        "type": "string"
    },
    {
        "name": "priorAuthorizationOnFile",
        "baseName": "priorAuthorizationOnFile",
        "type": "boolean"
    },
    {
        "name": "priorAuthorizationStatus",
        "baseName": "priorAuthorizationStatus",
        "type": "string"
    },
    {
        "name": "priorAuthorizationStartDate",
        "baseName": "priorAuthorizationStartDate",
        "type": "string"
    },
    {
        "name": "priorAuthorizationEndDate",
        "baseName": "priorAuthorizationEndDate",
        "type": "string"
    },
    {
        "name": "priorAuthorizationApprovalNumber",
        "baseName": "priorAuthorizationApprovalNumber",
        "type": "string"
    },
    {
        "name": "obtainPriorAuthorizationOrg",
        "baseName": "obtainPriorAuthorizationOrg",
        "type": "string"
    },
    {
        "name": "obtainPriorAuthorizationRequirements",
        "baseName": "obtainPriorAuthorizationRequirements",
        "type": "string"
    },
    {
        "name": "obtainPriorAuthorizationPhone",
        "baseName": "obtainPriorAuthorizationPhone",
        "type": "string"
    },
    {
        "name": "obtainPriorAuthorizationWebsite",
        "baseName": "obtainPriorAuthorizationWebsite",
        "type": "string"
    },
    {
        "name": "obtainPriorAuthorizationFax",
        "baseName": "obtainPriorAuthorizationFax",
        "type": "string"
    },
    {
        "name": "priorAuthorizationTurnaroundTime",
        "baseName": "priorAuthorizationTurnaroundTime",
        "type": "string"
    },
    {
        "name": "priorAuthorizationResponsibleOrg",
        "baseName": "priorAuthorizationResponsibleOrg",
        "type": "string"
    },
    {
        "name": "priorAuthorizationApprovedQuantity",
        "baseName": "priorAuthorizationApprovedQuantity",
        "type": "string"
    },
    {
        "name": "priorAuthorizationApprovedQuantityUsed",
        "baseName": "priorAuthorizationApprovedQuantityUsed",
        "type": "string"
    },
    {
        "name": "priorAuthorizationRenewalProcessExists",
        "baseName": "priorAuthorizationRenewalProcessExists",
        "type": "boolean"
    },
    {
        "name": "preDeterminationRequired",
        "baseName": "preDeterminationRequired",
        "type": "boolean"
    },
    {
        "name": "preDeterminationAvailable",
        "baseName": "preDeterminationAvailable",
        "type": "boolean"
    },
    {
        "name": "preDeterminationRequirement",
        "baseName": "preDeterminationRequirement",
        "type": "string"
    },
    {
        "name": "preDeterminationOnFile",
        "baseName": "preDeterminationOnFile",
        "type": "boolean"
    },
    {
        "name": "preDeterminationNumber",
        "baseName": "preDeterminationNumber",
        "type": "string"
    },
    {
        "name": "preDeterminationEndDate",
        "baseName": "preDeterminationEndDate",
        "type": "string"
    },
    {
        "name": "preDeterminationStartDate",
        "baseName": "preDeterminationStartDate",
        "type": "string"
    },
    {
        "name": "obtainPreDeterminationOrg",
        "baseName": "obtainPreDeterminationOrg",
        "type": "string"
    },
    {
        "name": "obtainPreDeterminationPhone",
        "baseName": "obtainPreDeterminationPhone",
        "type": "string"
    },
    {
        "name": "obtainPreDeterminationWebsite",
        "baseName": "obtainPreDeterminationWebsite",
        "type": "string"
    },
    {
        "name": "obtainPreDeterminationFax",
        "baseName": "obtainPreDeterminationFax",
        "type": "string"
    },
    {
        "name": "preDeterminationTurnaroundTime",
        "baseName": "preDeterminationTurnaroundTime",
        "type": "string"
    },
    {
        "name": "stepTherapyRequired",
        "baseName": "stepTherapyRequired",
        "type": "boolean"
    },
    {
        "name": "stepTherapyTreatment",
        "baseName": "stepTherapyTreatment",
        "type": "string"
    },
    {
        "name": "specialtyPharmacyAvailability",
        "baseName": "specialtyPharmacyAvailability",
        "type": "boolean"
    },
    {
        "name": "specialtyPharmacyName",
        "baseName": "specialtyPharmacyName",
        "type": "string"
    },
    {
        "name": "specialtyPharmacyPhoneNumber",
        "baseName": "specialtyPharmacyPhoneNumber",
        "type": "string"
    },
    {
        "name": "specialtyPharmacyExclusions",
        "baseName": "specialtyPharmacyExclusions",
        "type": "string"
    },
    {
        "name": "referralRequired",
        "baseName": "referralRequired",
        "type": "boolean"
    },
    {
        "name": "referralRequirements",
        "baseName": "referralRequirements",
        "type": "string"
    },
    {
        "name": "referralOnFile",
        "baseName": "referralOnFile",
        "type": "boolean"
    },
    {
        "name": "referralVisitsApproved",
        "baseName": "referralVisitsApproved",
        "type": "string"
    },
    {
        "name": "referralVisitsUsed",
        "baseName": "referralVisitsUsed",
        "type": "string"
    },
    {
        "name": "referralNumber",
        "baseName": "referralNumber",
        "type": "string"
    },
    {
        "name": "referralEffectiveDate",
        "baseName": "referralEffectiveDate",
        "type": "string"
    },
    {
        "name": "referralRecertDate",
        "baseName": "referralRecertDate",
        "type": "string"
    },
    {
        "name": "pcpName",
        "baseName": "pcpName",
        "type": "string"
    },
    {
        "name": "pcpPhone",
        "baseName": "pcpPhone",
        "type": "string"
    },
    {
        "name": "buyAndBillAvailability",
        "baseName": "buyAndBillAvailability",
        "type": "boolean"
    },
    {
        "name": "spendDownExist",
        "baseName": "spendDownExist",
        "type": "boolean"
    },
    {
        "name": "additionalNotes",
        "baseName": "additionalNotes",
        "type": "string"
    },
];
//# sourceMappingURL=medicalV1MedicalBiResultDefaultResponseData.js.map